const listeners = new Set();

export const track = (type, name, action, value, extra = {}) => {
  const event = {
    type,
    name: name || null,
    action,
    at: new Date().toISOString(),
    path: typeof window !== "undefined" ? window.location.pathname : "",
    ...extra,
  };
  if (value !== undefined && value !== null && value !== "") event.value = value;
  listeners.forEach((listener) => {
    try {
      listener(event);
    } catch (error) {
      return;
    }
  });
};

export const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
